module.exports = __webpack_public_path__ + "img/tlf_dep.8fa5b78f.png";